import * as React from 'react';
import type { SVGProps } from 'react';

const QuoteMark = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    width="76"
    height="65"
    viewBox="0 0 76 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35 11.025V1.01C25.43 1.205 17.225 4.215 11.22 9.745C4.535 15.91 1 24.985 1 36V63.025H35V29H15V28C15 23.36 17.455 18.995 21.91 15.7C25.62 12.96 30.445 11.245 35 11.025ZM0 36C0 12.03 16.12 0 36 0V12C26.68 12 16 18.675 16 28H36V64.025H0V36.025V36ZM75 11.025V1.01C65.425 1.205 57.22 4.215 51.22 9.745C44.535 15.91 41 24.985 41 36V63.025H75V29H55V28C55 23.36 57.455 18.995 61.91 15.7C65.62 12.96 70.445 11.245 75 11.025ZM40 36C40 12.03 56.12 0 76 0V12C66.68 12 56 18.675 56 28H76V64.025H40V36.025V36Z"
    />
  </svg>
);
export default QuoteMark;
